import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

export const DropdownValueArrayCardUiOptionsSchema = z.object({
  addButtonLabel: z.string().optional(),
  rows: z.number().optional(),
});

export type DropdownValueArrayCardUiOptions = z.infer<
  typeof DropdownValueArrayCardUiOptionsSchema
>;

export const DropdownValueArrayCardValueSchema = z.array(
  z.object({
    type: z.string(),
    jsonFile: z.string(),
  }),
);

export const DropdownValueArrayCardFieldSchema = makeFieldSchemaFromZod(
  DropdownValueArrayCardValueSchema.describe(
    'Dropdown and JSON file array card',
  ),
  DropdownValueArrayCardUiOptionsSchema,
);

export type DropdownValueArrayCardFieldProps =
  typeof DropdownValueArrayCardFieldSchema.type;

export const DropdownValueArrayCardSchema =
  DropdownValueArrayCardFieldSchema.schema;
